// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
const { createSelector } = require('reselect')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const CollectionListItemRecord = require('client-v2/common/containers/collection-select-modal/records/collection-list-item')
const { COLLECTION_UPDATE_PENDING } = require('client-v2/common/containers/collection-select-modal/actions')
const LazyImage = require('client-v2/common/components/lazy-image')
const tag = require('client-v2/common/utils/hyperscript')
const { VISIBILITY_PRIVATE } = require('client-v2/common/models/collection/record')

const bem = BemEntity('AddToCollectionItem')

class AddToCollectionItem extends React.PureComponent {
  constructor(props) {
    super(props)

    // Selectors

    this.imageSources = createSelector(
      [
        item => item['cover_image_urls'],
        item => item['cover_image_url']
      ],
      (coverImageUrls, coverImageUrl) => {
        if (coverImageUrls) {
          return [coverImageUrls.small, coverImageUrl]
        }
        return [coverImageUrl]
      }
    )

    // Event listeners

    this.onClick = this.onClick.bind(this)
  }

  // Event listeners

  onClick() {
    this.props.onClick(this.props.item)
  }

  // BEM helpers

  modifiers() {
    const { item } = this.props
    return {
      pending: item.isMixed === COLLECTION_UPDATE_PENDING,
      checked: item.isMixed === true
    }
  }

  renderImage() {
    return (
      tag(LazyImage, {
        className: bem.element('image'),
        sources: this.imageSources(this.props.item)
      })
    )
  }

  renderName() {
    return (
      tag('label', {
        className: bem.element('label')
      },
        this.props.item.name
      )
    )
  }

  renderPrivateIndicator(){
    if (this.props.item.visibility === VISIBILITY_PRIVATE) {
      return (
        tag('div', {
          className: bem.element('private')
        })
      )
    }
    return null
  }

  renderAction() {
    return tag('button', {
      className: bem.element('action')
    })
  }

  render() {
    return (
      tag('li', {
        className: classNames(
          this.props.className,
          bem.block(this.modifiers())
        ),
        onClick: this.onClick
      },
        this.renderImage(),
        this.renderName(),
        this.renderPrivateIndicator(),
        this.renderAction()
      )
    )
  }
}

AddToCollectionItem.propTypes = {
  // Values
  className: PropTypes.string,
  item: PropTypes.shape(
    CollectionListItemRecord.propTypes
  ).isRequired,
  // Callbacks
  onClick: PropTypes.func
}

module.exports = AddToCollectionItem
